/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TipoAnimaleDTO } from './TipoAnimaleDTO';
import {
    TipoAnimaleDTOFromJSON,
    TipoAnimaleDTOFromJSONTyped,
    TipoAnimaleDTOToJSON,
} from './TipoAnimaleDTO';

/**
 * 
 * @export
 * @interface ListinoPulciniDettaglioDTO
 */
export interface ListinoPulciniDettaglioDTO {
    /**
     * 
     * @type {number}
     * @memberof ListinoPulciniDettaglioDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ListinoPulciniDettaglioDTO
     */
    idListino?: number;
    /**
     * 
     * @type {number}
     * @memberof ListinoPulciniDettaglioDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {Date}
     * @memberof ListinoPulciniDettaglioDTO
     */
    inizioValidita?: Date;
    /**
     * 
     * @type {number}
     * @memberof ListinoPulciniDettaglioDTO
     */
    valore?: number;
    /**
     * 
     * @type {TipoAnimaleDTO}
     * @memberof ListinoPulciniDettaglioDTO
     */
    tipoAnimale?: TipoAnimaleDTO;
}

/**
 * Check if a given object implements the ListinoPulciniDettaglioDTO interface.
 */
export function instanceOfListinoPulciniDettaglioDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListinoPulciniDettaglioDTOFromJSON(json: any): ListinoPulciniDettaglioDTO {
    return ListinoPulciniDettaglioDTOFromJSONTyped(json, false);
}

export function ListinoPulciniDettaglioDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListinoPulciniDettaglioDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'idListino': !exists(json, 'idListino') ? undefined : json['idListino'],
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'inizioValidita': !exists(json, 'inizioValidita') ? undefined : (new Date(json['inizioValidita'])),
        'valore': !exists(json, 'valore') ? undefined : json['valore'],
        'tipoAnimale': !exists(json, 'tipoAnimale') ? undefined : TipoAnimaleDTOFromJSON(json['tipoAnimale']),
    };
}

export function ListinoPulciniDettaglioDTOToJSON(value?: ListinoPulciniDettaglioDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'idListino': value.idListino,
        'idTipoAnimale': value.idTipoAnimale,
        'inizioValidita': value.inizioValidita === undefined ? undefined : (value.inizioValidita.toISOString()),
        'valore': value.valore,
        'tipoAnimale': TipoAnimaleDTOToJSON(value.tipoAnimale),
    };
}

